import type { ReactNode } from 'react';
import { cn } from '@shared/utils';

interface OptionProps {
  className?: string;
  icon: ReactNode;
  title: string;
  description: string;
  onClick: () => void;
}

export const Option = (props: OptionProps) => {
  return (
    <div className={cn('group mb-7.5 flex cursor-pointer', props.className)} onClick={props.onClick}>
      <div className='mt-1.25 mr-4.5 flex h-9.75 w-9.75 items-center justify-center'>
        {typeof props.icon === 'string' ? <img className='max-h-full max-w-full' src={props.icon} alt='text' /> : props.icon}
      </div>
      <div className='text-black'>
        <div className='h-7.5 text-[19px] font-medium'>{props.title}</div>
        <div className={cn('text-sm font-medium', 'group-hover:underline')}>{props.description}</div>
      </div>
    </div>
  );
};
